import * as React from "react";
import * as ReactDOM from "react-dom";
import bugsnag from "@bugsnag/js";
import bugsnagReact from "@bugsnag/plugin-react";
import { ApolloClient } from "apollo-client";
import { ApolloProvider } from "react-apollo";
import { HttpLink } from "apollo-link-http";
import { ApolloLink } from "apollo-link";
import { setContext } from "apollo-link-context";
import { WebSocketLink } from "apollo-link-ws";
import { InMemoryCache } from "apollo-cache-inmemory";
import { getOperationAST } from "graphql";

import App from "./App";
import ContextProvider from "./Components/ContextProvider";

// Error boundary fallback component
import FallbackComponent from "./Components/ErrorBoundary";

import { GRAPHCOOL_API, GRAPHCOOL_SUBSCRIPTIONS_API } from "./Utils/API";
import { AUTH_USER_TOKEN } from "./Utils/LocalStorage";

import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
// import registerServiceWorker from "./registerServiceWorker";
import { unregister } from "./registerServiceWorker";

// Bugsnag
const bugsnagClient = bugsnag("1e40f7137f821e04a60af5f59d16c9e6");
bugsnagClient.use(bugsnagReact, React);
const ErrorBoundary = bugsnagClient.getPlugin("react");

const authLink = setContext((_, { headers }) => {
  // Get the authentication token from local storage if it exists
  const token = localStorage.getItem(AUTH_USER_TOKEN);
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
      "Access-Control-Allow-Credentials": true
    }
  };
});

const link = ApolloLink.split(
  operation => {
    const operationAST = getOperationAST(
      operation.query,
      operation.operationName
    );
    return !!operationAST && operationAST.operation === "subscription";
  },
  new WebSocketLink({
    uri: GRAPHCOOL_SUBSCRIPTIONS_API,
    options: {
      reconnect: true
    }
  }),
  new HttpLink({ uri: GRAPHCOOL_API })
);

const apolloClient = new ApolloClient({
  link: authLink.concat(link),
  cache: new InMemoryCache()
});

const Root: React.SFC<{}> = () => (
  <ErrorBoundary FallbackComponent={FallbackComponent}>
    <ContextProvider>
      <ApolloProvider client={apolloClient}>
        <App />
      </ApolloProvider>
    </ContextProvider>
  </ErrorBoundary>
);

ReactDOM.render(<Root />, document.getElementById("root") as HTMLElement);
// registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/index.tsx